import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface CreditFrameworkResource
    extends ng.resource.IResourceClass<
        ng.resource.IResource<CreditFrameworkDto>
    > {
    getCreditFrameworksForLoggedInTso: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditFrameworkDto>
    >;
    createCreditFramework: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditFrameworkDto>
    >;
    updateCreditFramework: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditFrameworkDto>
    >;
    deleteCreditFramework: ng.resource.IResourceMethod<void>;
}

function creditFrameworkResource(
    $resource: ng.resource.IResourceService
): CreditFrameworkResource {
    return <CreditFrameworkResource>$resource(
        config.monolithApi + '/credit-limit/',
        { shipperRefId: '@shipperRefId' },
        {
            getCreditFrameworksForLoggedInTso: {
                method: 'GET',
                url: config.monolithApi + '/credit-framework/',
                isArray: true
            },
            createCreditFramework: {
                method: 'POST',
                url: config.monolithApi + '/credit-framework/'
            },
            updateCreditFramework: {
                method: 'PUT',
                url: config.monolithApi + '/credit-framework/'
            },
            deleteCreditFramework: {
                method: 'DELETE',
                url: config.monolithApi + '/credit-framework/:refId'
            }
        }
    );
}

angular
    .module('app')
    .factory('creditFrameworkResource', creditFrameworkResource);
